import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { BrandingProvider } from './contexts/BrandingContext';
import { AuthRouter } from './components/auth/AuthRouter';

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <BrandingProvider templateType="business">
          <AuthProvider>
            <Routes>
              {/* Organization-based routes */}
              <Route path="/:orgId/*" element={<AuthRouter />} />
              {/* Legacy and auth routes */}
              <Route path="/*" element={<AuthRouter />} />
            </Routes>
          </AuthProvider>
        </BrandingProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
